import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import FormHeader from '../../components/FormHeader/FormHeader'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateOrganizationTypes = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    // Update-validation-rules-marker
    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      typeName: yup.string().max(60).typeError('must be string')
    }),

    // Create-validation-rules-marker
    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      typeName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('organizationTypeName')))
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      if (!id) {
        const data = {
          ...values
        }
        storeOrganizationTypes(data)
      } else {
        const payload = {
          data: {
            ...values
          },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateOrganizationTypes(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    if (id) {
      retrieveOrganizationTypes(id)
    } else {
      setFormValues({})
    }

    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function storeOrganizationTypes(data) {
    try {
      await request(api.storeOrganizationTypes(data))
      notification.success({
        description: getMessage('successStoreOrganizationTypes'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveOrganizationTypes(id) {
    try {
      const response = await request(api.retrieveOrganizationTypes(id))
      console.tron.log('response', response)
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateOrganizationTypes(payload) {
    try {
      console.tron.log('updateOrganizationTypes')
      const { id, data } = payload
      await request(api.updateOrganizationTypes(id, data))
      notification.success({
        description: getMessage('successUpdateOrganizationTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id !== null ? getMessage('updateOrganizationTypes') : getMessage('createOrganizationTypes')
  }

  function renderHeader(submitForm) {
    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getTitle()}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            <Button type="primary" onClick={() => submitForm()}>
              {id ? getMessage('update') : getMessage('register')}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({ ...formValues, [field]: value })
            return setFieldValue(field, value)
          }

          return (
            <Form className="organizationTypes-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <FormHeader title={getMessage('tab.info')} orientation="left" type="horizontal" />
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="typeName"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateOrganizationTypes
